<script>
import webservice from '@/utils/webservice'
export default {
  name: 'UnpublishCarComponent',
  data () {
    return {
      loading: false,
      carCode: null
    }
  },
  methods: {
    onPressBtnUnpublishConfirm () {
      let requestLocalTime = new Date().getTime()
      this.loading = true
      webservice.publications.unPublish(this.carCode).then(response => {
        console.log(`response: ${JSON.stringify(response)}`)
        let responseLocalTime = new Date().getTime()
        let diffTime = responseLocalTime - requestLocalTime
        if (diffTime < 2000) {
          setTimeout((self) => {
            self.loading = false
            self.$emit('onUnpublishCar', response)
            self.close()
          }, 2000 - diffTime, this)
        } else {
          this.loading = false
          this.$emit('onUnpublishCar', response)
          this.close()
        }
      })
    },
    openForCar (carCode) {
      this.reset()
      this.carCode = carCode

      window.$('#modal_unpublish_car').modal()
    },
    close () {
      window.$('#modal_unpublish_car').modal('hide')
    },
    reset () {
      this.carCode = null
      this.loading = false
    }
  }
}
</script>
<template>
  <div>
    <div class="modal fase" role="dialog" id="modal_unpublish_car">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4>Despublicar vehículo</h4>
          </div>

          <div class="modal-body">
            <div class="center_query">
              ¿Quieres despublicar este vehículo?
            </div>
          </div>
          <div class="modal-footer">

            <button type="button" class="btn btn-info" v-bind:class="{disabled: loading}" v-on:click="onPressBtnUnpublishConfirm">
              <span v-if="!loading">Despublicar</span>
              <i class="fa fa-refresh fa-spin" v-if="loading"></i>
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/UnpublishComponent.vue